import type { HTMLAttributes, PropsWithChildren } from 'react'
import { forwardRef } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

const MODAL_TRANSITION_DURATION = 300 /** in ms */

const Backdrop = styled.div`
  z-index: ${zIndex.modal};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  height: 100dvh;
  background-color: rgba(0,0,0,.5);
  backdrop-filter: blur(0);
  display: flex;
  animation-iteration-count: 1;
  animation-duration: ${MODAL_TRANSITION_DURATION}ms;
  animation-fill-mode: forwards;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  transition: opacity ${MODAL_TRANSITION_DURATION}ms ease-in-out, backdrop-filter ${MODAL_TRANSITION_DURATION}ms ease-in-out;

  &.visible {
    opacity: 1;
    backdrop-filter: blur(2px);
    pointer-events: auto;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`

interface Props extends HTMLAttributes<HTMLDivElement> {
  isVisible: boolean
}

const PreviewableModalBackdrop = forwardRef<HTMLDivElement, PropsWithChildren<Props>>((props, ref) => {
  const {
    isVisible,
    children,
    ...rest
  } = props

  return <Backdrop
    {...rest}
    ref={ref}
    className={clsx({ visible: isVisible })}
  >
    {children}
  </Backdrop>
})

export default PreviewableModalBackdrop
